import { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@heroui/react';
import cn from 'classnames';

export const ATTENDANCE_OPTIONS = [
  { value: 1 as const, label: '1.0', color: 'bg-[#CFF7D3] text-black' },
  { value: 0.5 as const, label: '0.5', color: 'bg-[#FFF9C4] text-black' },
  { value: 0 as const, label: '0.0', color: 'bg-[#FDD3D0] text-black' },
];

type AttendanceValue = 0 | 0.5 | 1;

interface AttendanceStatusSelectProps {
  value: AttendanceValue | null;
  onChange: (value: AttendanceValue) => void;
  isDisabled?: boolean;
}

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path
      d="M3.33325 8.66667L5.99992 11.3333L12.6666 4.66667"
      stroke="#1E1E1E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AttendanceStatusSelect = ({
  value,
  onChange,
  isDisabled,
}: AttendanceStatusSelectProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const selected = value ?? 0;

  const trigger = (
    <button
      type="button"
      disabled={isDisabled}
      className="flex h-[30px] w-[54px] shrink-0 items-center justify-between rounded bg-[#F5F5F5] px-1.5 text-sm leading-none text-[#1E1E1E] disabled:opacity-50"
    >
      <span>{selected.toFixed(1)}</span>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        className={cn('text-[#757575] transition-transform', isOpen && 'rotate-180')}
      >
        <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      </svg>
    </button>
  );

  if (isDisabled) {
    return trigger;
  }

  return (
    <Popover placement="bottom-end" offset={4} isOpen={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger>{trigger}</PopoverTrigger>
      <PopoverContent className="min-w-[108px] rounded-lg p-1 shadow-md">
        <ul className="flex w-full flex-col gap-0.5">
          {ATTENDANCE_OPTIONS.map((opt) => {
            const isSelected = opt.value === selected;

            return (
              <li key={opt.label}>
                <button
                  type="button"
                  className="flex w-full items-center gap-1 rounded-md px-1 py-1 hover:bg-[#F5F5F5]"
                  onClick={() => {
                    onChange(opt.value);
                    setIsOpen(false);
                  }}
                >
                  <span
                    className={cn(
                      'inline-flex flex-1 items-center justify-center rounded-md px-2 py-1 text-sm font-medium text-black',
                      opt.color,
                    )}
                  >
                    {opt.label}
                  </span>
                  <span className="flex h-3.5 w-3.5 shrink-0 items-center justify-center">
                    {isSelected ? <CheckIcon /> : null}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      </PopoverContent>
    </Popover>
  );
};
